import { FulfillmentStatus } from 'src/utils/enums';
import isDeliveredOrShipped from './isDeliveredOrShipped';

interface Shipment {
  shipmentDate?: string;
  status?: FulfillmentStatus;
}

export const hasLastShipment = (shipment: Shipment): boolean => {
  return (
    !!shipment?.shipmentDate &&
    !!shipment?.status &&
    isDeliveredOrShipped(shipment.status)
  );
};
